import PromoPreview from "components/PromoPreview";
import { InfotextProductModel, ProductProps } from "models/WebShop";
import { useState } from "react";
import { useParams } from "react-router-dom";


const InfotextProduct = ({ handleAddProduct, handleFormValidation, initialProduct }: ProductProps) => {

    const params = useParams();
    const [infotext, setInfotext] = useState(
        initialProduct?.infotext ?? ""
    );

    const defaultProduct: InfotextProductModel = {
        webShopProductId: 103,
        documentId: params.id ?? "",
        path: "",
        name: "Beskrivelse av bedriften",
        payload: "",
        id: params.id ? params.product + params.id : "",
        price: 1500,
        basePrice: 1500,
        infotext: "",
        description: "",
        linkText: ""

    };

    const handleInputChange = (value: string) => {
        setInfotext(value);

        if (value.length === 0) {
            handleFormValidation(false);
        }
        else {
            const updatedProduct: InfotextProductModel = {
                ...defaultProduct,
                infotext: value,
            };
            handleAddProduct(updatedProduct);
            handleFormValidation(true);
        }

    };

    return <><div className="d-flex flex-column flex-md-row gap-4 mb-3 mb-md-4 align-items-center">
        <div className="order-md-last text-center">
            <img src="/min-bedrift-ill-beskrivelse.svg" width="800" height="270" alt="Beskrivelse av bedriften" className="img-fluid cc-mw-220"></img>
        </div>
        <div>
            <ul className="text-muted mb-0 cc-ul-spaced-1">
                <li>En god firmabeskrivelse gjør profilen din mer levende, bygger tillit og kan bidra til at flere tar kontakt.</li>
                <li>Presenter bedriften på en engasjerende måte.</li>
                <li>Forklar hva bedriften tilbyr og hva som gjør dere unike. </li>
            </ul>
        </div>
    </div>

        <textarea className="form-control border-primary border-opacity-50 mb-2" id="description" aria-label="Beskrivelse av bedriften" maxLength={1000} onChange={(e) => handleInputChange(e.target.value)} placeholder="Beskriv din bedrifts virksomhet og fordelene ved å velge din bedrift…" style={{ overflow: "hidden", resize: "none", height: "300px" }} value={infotext}></textarea>
        <p className="text-muted mb-0 cc-fs-xs"><span id="charCounter">{infotext.length} / 1000</span> tegn. Teksten vises på din bedrifts infoside.
            Forkortet tekst vises også i din oppføring på resultatsider (ikke i mobilvisning). NB! Linjeskift vil ikke bli bevart.</p>
        <PromoPreview id={params.id ?? ""} infoText={infotext}></PromoPreview>
    </>

};

export default InfotextProduct;